import { lazy, Suspense, useCallback, type CSSProperties, type Ref } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { itx } from "../../../src/translationItx/itx";
import type { Model3DDefinition } from "./Model3D";
import "./modelView.scss";

const ModelViewRenderer = lazy(() => import("./ModelViewRenderer"));

export interface ModelViewActions {
  front(): void;
  perspective(): void;
}

export interface ModelViewControlProps<P> {
  model: Model3DDefinition<P>;
  parameters: P;
  className?: string;
  style?: CSSProperties;
  showViewButtons?: boolean;
  photoQualityAtRest?: boolean;
  viewActionsRef?: Ref<ModelViewActions>;
}

/** Embeddable display only. The surrounding context/product data chooses the model. */
export function ModelViewControl<P>({ model, parameters, className, style, showViewButtons = true, photoQualityAtRest = false, viewActionsRef }: ModelViewControlProps<P>) {
  const loadModel = useCallback(async () => {
    const create = await model.load();
    return create(parameters);
  }, [model, parameters]);
  return <div className={["C1_modelViewControl", className].filter(Boolean).join(" ")} style={style}>
    <ErrorBoundary key={model.id} resetKeys={[model, parameters]} fallback={<p role="alert">{itx("c1.button3d.loadError", "Die 3D-Vorschau konnte nicht geladen werden.")}</p>}>
      <Suspense fallback={<p role="status">{itx("c1.button3d.loading", "3D-Vorschau wird geladen …")}</p>}>
        <ModelViewRenderer loadModel={loadModel} showViewButtons={showViewButtons} label={model.label} photoQualityAtRest={photoQualityAtRest} viewActionsRef={viewActionsRef} />
      </Suspense>
    </ErrorBoundary>
  </div>;
}
